import { PayloadAction } from "@reduxjs/toolkit";
import { Error } from "../../../../utl/models/Error";
import { UserState } from "../models/UserState";

const setErrorTelVendor = (state: UserState, action: PayloadAction<Error>) => {
    state.vendor.telError = action.payload.error;
}

export default setErrorTelVendor;